<template>
    <div class="pt-5 pb-5">
        <div style="width: 8.5in; margin-left: auto; margin-right: auto;">
            <table>
                <template v-for="returnItem in manufacturerReturn.return_items">
                    <ReturnItem :returnItem="returnItem" isManufacturerReturn="true" />
                </template>
            </table>
        </div>
    </div>
</template>

<script>
import ReturnItem from '@/Components/Returns/ReturnItem'

export default {
    components: {
        ReturnItem,
    },
    props: {
        manufacturerReturn: Object,
    },
}
</script>
